import { color } from "emoreg/const";

export const radioColor = {
  grey: { borderColor: color.grey.base },
  blue: { borderColor: color.blue.base },
};
